import React from 'react';
import{IoMdShare}from "react-icons/io";
const PWAShareButton = () => {
  const shareContent = async () => {
    try {
      await navigator.share({
        title: 'BridgenApp',
        text: 'Check out this amazing social shopping app!',
        url: 'https://bridgenapp.com',
      });
    } catch (err) {
      // Fallback for when Web Share isn't supported
      if (navigator.clipboard) {
        await navigator.clipboard.writeText('https://bridgenapp.com');
        alert('Link copied to clipboard!');
      } else {
        // Final fallback - open with generic share options
        window.open(
          'mailto:?subject=BridgenApp&body=Check%20out%20https://bridgenapp.com',
          '_blank'
        );
      }
    }
  };

  return (
    <button 
      onClick={shareContent}
      className="pwa-share-button"
      style={{height:'25px', borderRadius: '5px', color:'#17a2b8'}}
    >
      <IoMdShare/>
    </button>
  );
};

export default PWAShareButton;